<template>
  <div>
    <!-- Filter -->
    <v-card dark class="mb-4 pa-3" color="rgba(255,255,255,0.05)" flat>
      <v-row dense>
        <v-col cols="12" sm="6" md="4">
          <v-select
            :value="filterStudio"
            @input="$emit('update:filterStudio', $event)"
            :items="studioOptions"
            item-text="name"
            item-value="_id"
            label="Studio"
            outlined
            dense
            dark
            hide-details />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-select
            :value="filterStatus"
            @input="$emit('update:filterStatus', $event)"
            :items="statusOptions"
            label="Status"
            outlined
            dense
            dark
            hide-details />
        </v-col>
        <v-col cols="12" sm="12" md="4" class="d-flex align-center">
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('reload')">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Stats -->
    <v-row dense class="mb-3">
      <v-col cols="6" md="3" v-for="stat in stats" :key="stat.value">
        <v-card dark color="rgba(255,255,255,0.04)" flat class="pa-3">
          <div class="caption grey--text">{{ stat.label }}</div>
          <div class="text-h5 font-weight-bold mt-1" :style="{ color: stat.color }">{{ stat.count }}</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Liste -->
    <div v-if="loading" class="text-center pa-12">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
    </div>

    <div v-else-if="orders.length === 0" class="text-center pa-12 grey--text">
      <v-icon size="64" color="grey darken-1">mdi-clipboard-remove-outline</v-icon>
      <div class="mt-3 subtitle-1">Keine Bestellungen gefunden</div>
    </div>

    <v-card v-else dark color="rgba(255,255,255,0.03)" flat>
      <v-data-table
        dark
        :headers="headers"
        :items="orders"
        :items-per-page="25"
        class="transparent"
        no-data-text="Keine Bestellungen"
        @click:row="$emit('open-detail', $event)">
        <template v-slot:item.createdAt="{ item }">
          {{ $moment(item.createdAt).format("DD.MM.YYYY HH:mm") }}
        </template>
        <template v-slot:item.id="{ item }">
          <span class="font-weight-bold">#{{ item._id.slice(-6).toUpperCase() }}</span>
        </template>
        <template v-slot:item.createdBy="{ item }">
          {{ item.createdBy ? item.createdBy.vorname + " " + item.createdBy.nachname : "-" }}
        </template>
        <template v-slot:item.studio="{ item }">
          {{ item.studio ? item.studio.name : "-" }}
        </template>
        <template v-slot:item.itemCount="{ item }">
          <v-chip x-small color="blue-grey" dark> {{ totalItems(item) }} Stk </v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip x-small :color="statusColor(item.status)" dark>
            {{ statusLabel(item.status) }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AdminOrdersList",
  props: {
    orders: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    studioOptions: { type: Array, default: () => [] },
    filterStudio: { type: String, default: "all" },
    filterStatus: { type: String, default: "all" },
  },
  data() {
    return {
      headers: [
        { text: "Datum", value: "createdAt" },
        { text: "Nr.", value: "id", sortable: false },
        { text: "Erstellt von", value: "createdBy" },
        { text: "Studio", value: "studio" },
        { text: "Artikel", value: "itemCount", sortable: false, align: "center" },
        { text: "Status", value: "status" },
      ],
      statusOptions: [
        { text: "Alle", value: "all" },
        { text: "Erhalten", value: "received" },
        { text: "Bestätigt", value: "confirmed" },
        { text: "Unterwegs", value: "shipping" },
        { text: "Geliefert", value: "delivered" },
      ],
    }
  },
  computed: {
    stats() {
      const c = (s) => this.orders.filter((o) => o.status === s).length
      return [
        { label: "Erhalten", count: c("received"), value: "received", color: "#9ca3af" },
        { label: "Bestätigt", count: c("confirmed"), value: "confirmed", color: "#f59e0b" },
        { label: "Unterwegs", count: c("shipping"), value: "shipping", color: "#3b82f6" },
        { label: "Geliefert", count: c("delivered"), value: "delivered", color: "#10b981" },
      ]
    },
  },
  methods: {
    totalItems(order) {
      return (order.items || []).reduce((sum, i) => sum + (i.quantity || 0), 0)
    },
    statusColor(s) {
      if (s === "delivered") return "green"
      if (s === "shipping") return "blue"
      if (s === "confirmed") return "amber darken-2"
      return "grey darken-1"
    },
    statusLabel(s) {
      if (s === "delivered") return "Geliefert"
      if (s === "shipping") return "Unterwegs"
      if (s === "confirmed") return "Bestätigt"
      return "Erhalten"
    },
  },
}
</script>

<style scoped>
.transparent {
  background: transparent !important;
}
</style>
